export const validateReadingEntry = async ({
  newReading,
  assetId,
  meterId,
  assetMeters = [],
  setErrors,
  validateMeterReadingApi,
  requireAssetId = true,
  assetErrorKey = 'assetId',
  meterErrorKey = 'metersId',
  dateErrorKey = 'readingDate',
  valueErrorKey = 'value',
}) => {
  const errs = {};
  const parsedValue = parseFloat(newReading.value);

  if (requireAssetId && !assetId) {
    errs[assetErrorKey] = 'Asset required';
  }

  if (!meterId) {
    errs[meterErrorKey] = 'Meter required';
  }

  if (!newReading.readingDate) {
    errs[dateErrorKey] = 'Date is required';
  }

  if (Number.isNaN(parsedValue)) {
    errs[valueErrorKey] = 'Value is required';
  }

  const assetMeterRecord = assetMeters.find(
    (am) => am.meterId === meterId && (!requireAssetId || am.assetId === assetId),
  );

  if (!assetMeterRecord && assetId && meterId) {
    errs[meterErrorKey] = 'Selected meter is not assigned to this asset';
  }

  if (Object.keys(errs).length > 0) {
    setErrors(errs);
    return { isValid: false, parsedValue: null, assetMeterRecord: null };
  }

  try {
    const { isValid, errors: backendErrors } = await validateMeterReadingApi({
      assetId,
      meterId,
      assetMeterId: assetMeterRecord?.id,
      readingDate: new Date(newReading.readingDate).toISOString(),
      meterReading: parsedValue,
    });

    if (!isValid) {
      setErrors(backendErrors);
      return { isValid: false, parsedValue: null, assetMeterRecord };
    }

    setErrors({});
    return { isValid: true, parsedValue, assetMeterRecord };
  } catch (error) {
    console.error('validate meter reading', error);
    setErrors({ [valueErrorKey]: error.response?.data?.message || 'Validation failed' });
    return { isValid: false, parsedValue: null, assetMeterRecord: null };
  }
};

export const handleSaveMeterReading = async ({
  newReading,
  assetId,
  meterId,
  assetMeters,
  setErrors,
  validateMeterReadingApi,
  createReading,
  updateReading,
  editingId,
  onSuccess,
  requireAssetId = true,
  assetErrorKey,
  meterErrorKey,
  dateErrorKey,
  valueErrorKey,
  validateReadingFn,
}) => {
  const { isValid, parsedValue } = validateReadingFn
    ? await validateReadingFn()
    : await validateReadingEntry({
      newReading,
      assetId,
      meterId,
      assetMeters,
      setErrors,
      validateMeterReadingApi,
      requireAssetId,
      assetErrorKey,
      meterErrorKey,
      dateErrorKey,
      valueErrorKey,
    });

  if (!isValid) return false;

  const payload = {
    value: parsedValue,
    metersId: meterId,
    assetId,
    readingDate: new Date(newReading.readingDate).toISOString(),
  };

  try {
    if (editingId) {
      await updateReading(editingId, payload);
    } else {
      await createReading(payload);
    }

    if (onSuccess) {
      await onSuccess();
    }

    return true;
  } catch (error) {
    console.error('Error saving reading', error);
    return false;
  }
};
